// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"71476d4a","239":"2f822dd7","455":"c3454b99","578":"c144115d","951":"cb647873","977":"4dc61a07"}[chunkId] + ".chunk.js";
};